@if (sharedProject && sharedProject?.name) {
  <div class="project-name">
    <strong>{{ sharedProject?.name }}</strong>
  </div>
}
<div>
  <div class="owner">
    @if (
      sharedProject?.email &&
      !sharedProject?.owner.firstName &&
      !sharedProject?.owner.lastName &&
      !sharedProject?.owner.companyName
      ) {
      <p
        >
        {{ sharedProject?.email }}
      </p>
    }
    @if (sharedProject?.owner) {
      <div>
        @if (sharedProject?.owner.firstName || sharedProject?.owner.lastName) {
          <p>
            {{ sharedProject?.owner.firstName }} {{ sharedProject?.owner.lastName }}
          </p>
        }
        @if (sharedProject?.owner.companyName) {
          <p>
            {{ sharedProject?.owner.companyName }}
          </p>
        }
      </div>
    }
  </div>
  <p>
    <strong>{{ 'share_panel_someone_shared' | translate }}</strong>
  </p>
</div>
@if (authorizationService.isLoggedIn()) {
  <p>
    {{ 'share_panel_logged_in_message' | translate }}
  </p>
}
@if (!authorizationService.isLoggedIn()) {
  <p>
    {{ 'share_panel_not_logged_in_message' | translate }}
  </p>
}
<div class="buttonsWrapper">
  @if (authorizationService.isLoggedIn()) {
    <div class="buttons">
      <button
        [disabled]="!user.isPremium"
        [glPremium]="true"
        outline-button
        (click)="editSharedProject()"
        >
        <gl-icon name="openProject"></gl-icon>
        {{ 'open' | translate }}
      </button>
      <button outline-button (click)="closeSharedView()">
        <gl-icon name="close-2"></gl-icon>
        {{ 'close' | translate }}
      </button>
    </div>
  }
  @if (!authorizationService.isLoggedIn()) {
    <button outline-button (click)="goToLogin()">
      {{ 'sign_in' | translate }}
    </button>
  }
  <button outline-button id="pdf" (click)="generatePDF()">
    <gl-icon name="pdfIco"></gl-icon>
    {{ 'share_panel_download_pdf' | translate }}
  </button>
</div>
@if (sharedProject && sharedProject?.note) {
  <div class="note-wrapper">
    <div>
      <strong>{{ 'project_notes' | translate }}:</strong>
    </div>
    <div class="note">
      {{ sharedProject?.note }}
    </div>
  </div>
}
